import { Breadcrumbs, Link, Skeleton, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export type FramesBreadcrumbItem = {
  label: string;
  to?: string;
};

/**
 * Breadcrumb for the Frames list and frame viewer, rendered exactly like the
 * documents page breadcrumb (which isn't reused directly because its crumbs
 * double as drag-and-drop folder drop targets).
 */
export const FramesBreadcrumb = ({
  isLoading = false,
  items,
}: {
  isLoading?: boolean;
  items: FramesBreadcrumbItem[];
}) => {
  if (isLoading) {
    return <Skeleton variant="rounded" height={24} width={220} />;
  }

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {items.map((item, index) =>
        item.to ? (
          <Link
            color="inherit"
            component={RouterLink}
            key={index}
            to={item.to}
            underline="hover"
          >
            {item.label}
          </Link>
        ) : (
          <Typography component="span" key={index}>
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  );
};
